// @flow
import * as React from 'react';
import { connect } from "react-redux";
import moment from 'moment';
import { DFPSlotsProvider, AdSlot, DFPManager } from 'react-dfp';
import { isMobile } from '../../utils';
import * as selectors from "../../modules/selectors";

const sizes = {
	top: {
		desktop: [970, 90],
		mobile: [320, 50],
	},
	bottom: {
		desktop: [728, 90],
		mobile: [320, 50],
	},
	sidebar: {
		desktop: [300, 250],
		mobile: [300, 250],
	}
};

const positions = {
	top: 1,
	sidebar: 2,
	bottom: 3,
};

type Props = {
	adUnit?: string,
	size?: string,
	user: {
		supported_club_name: string,
		birthday: string,
	},
}

class AdComp extends React.Component<Props> {
	get over18() {
		const { user: { birthday } } = this.props;
		const age = moment().diff(birthday, 'years');

		return age >= 18;
	}

	render() {
		const { adUnit, size } = this.props;

		if(!adUnit || !size) {
			return null;
		}

		const
			type_size = isMobile() ? 'mobile' : 'desktop',
			current_size = sizes[size][type_size] || sizes.top[type_size],
			birthYear = this.over18 ? 'over18' : 'under18';

		const
			{ user: {
				supported_club_name,
				birthday
			} } = this.props,
			age = moment(birthday).format('YYYY');

		return (
			<DFPSlotsProvider
				dfpNetworkId='78756360'
				targetingArguments={{
					gen: "unknown",
					clubfav: supported_club_name,
					birthYear,
					age,
					pos: positions[size]
				}}
			>
				<AdSlot
					adUnit={`NRLDraft.web/${adUnit}/index`}
					sizes={[current_size]} />
				{DFPManager.refresh()}
			</DFPSlotsProvider>
		);
	}
}

const mapStateToProps = state => ({
	user: selectors.getUser(state)
});

export const Ad = connect(
	mapStateToProps,
	null,
)(AdComp);

export default Ad;


// WEBPACK FOOTER //
// ./src/components/Ad/index.js